import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
} from "@mui/material";
import PreviewIcon from "@mui/icons-material/Preview";
import CloseIcon from "@mui/icons-material/Close";
import PreviewCarousel from "./PreviewCarousel";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

/**
 * root Preview Disruption Component
 * @param {boolean} fullWidth Add fullWidth to button
 * @param {boolean} disabled Add disabled to button
 * @param {string} previewType Type of Preview "ALL|CREATE"
 * @param {Array} createData Data from Create Disruption Form, CREATE type only
 * @returns Button to open Preview Disruption Dialog
 */
const PreviewDisruption = ({
  fullWidth,
  previewType,
  disabled,
  createData,
}) => {
  const { t } = useTranslation("smrtDisruption");
  const { t: tCommon } = useTranslation();
  const { disruptions } = useSelector((state) => state.smrtDisruption);
  const [open, setOpen] = useState(false);
  const [disruptionData, setDisruptionData] = useState([]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (open === true) {
      setDisruptionData(previewType === "CREATE" ? createData() : disruptions);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  return (
    <>
      <Button
        startIcon={<PreviewIcon fontSize="small" />}
        variant="contained"
        fullWidth={fullWidth}
        sx={{ boxShadow: 3 }}
        onClick={handleOpen}
        disabled={
          disabled || (disruptions?.length === 0 && previewType === "ALL")
        }
      >
        {t("preview.previewBtn")}
      </Button>

      <Dialog open={open} maxWidth={"xl"}>
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {t("preview.previewTitle")}
          <IconButton onClick={handleClose}>
            <CloseIcon fontSize="small" color="inherit" />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <PreviewCarousel
            previewType={previewType}
            disruptions={disruptionData}
          />
        </DialogContent>
        <DialogActions>
          <Button fullWidth variant="outlined" onClick={handleClose}>
            {tCommon("closeBtn")}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default PreviewDisruption;
